import {connect} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getAllVerifyResponse} from "../store/logIn";
import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import {useTranslation} from "react-i18next";
import AdminFilter from "../blocks/AdminFilter";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SearchIcon from "@mui/icons-material/Search";
import {toast} from "react-toastify";
import {getSectionReports, deleteSectionReport, updateSectionStatus, messageReset} from "../store/sectionReports";
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    FormControl, InputAdornment, InputLabel, MenuItem, OutlinedInput,
    Pagination, Select, TextField
} from "@mui/material";

const PAGE_SIZE = 20

const SECTION_LABELS = {
    biznes_reja:        'section_biznes_reja',
    kuzgi_qishki:       'section_kuzgi_qishki',
    mehnat_muhofazasi:  'section_mehnat_muhofazasi',
    yongin_xavfsizligi: 'section_yongin_xavfsizligi',
    inventarizatsiya:   'section_inventarizatsiya',
}

// Jadval ustunlari (ko'rish uchun)
const SECTION_COLUMNS = {
    kuzgi_qishki: [
        {key: 'tadbirlar_nomi',  label: 'Тадбирлар номи'},
        {key: 'muddati',         label: 'Муддати'},
        {key: 'masul_shaxs',     label: 'Масъул шахс'},
        {key: 'sarf_mablag',     label: 'Сарфланадиган маблағ'},
    ],
    yongin_xavfsizligi: [
        {key: 'tadbirlar_nomi',  label: 'Тадбирлар номи'},
        {key: 'muddati',         label: 'Муддати'},
        {key: 'masul_shaxs',     label: 'Масъул шахс'},
        {key: 'sarf_mablag',     label: 'Сарфланадиган маблағлар'},
    ],
    mehnat_muhofazasi: [
        {key: 'tadbirlar_nomi',  label: 'Тадбирлар номи'},
        {key: 'muddati',         label: 'Муддати'},
        {key: 'masul_shaxs',     label: 'Масъул шахс'},
        {key: 'sarf_mablag',     label: 'Сарфланадиган маблағ'},
    ],
}

const STATUS_COLORS = {
    korib_chiqilmoqda: {bg: '#fff3cd', color: '#856404', label: "Ko'rib chiqilmoqda"},
    tasdiqlandi:       {bg: '#d1e7dd', color: '#0f5132', label: 'Tasdiqlandi'},
    rad_etildi:        {bg: '#f8d7da', color: '#842029', label: 'Rad etildi'},
}

function StatusBadge({status}) {
    const s = STATUS_COLORS[status] || STATUS_COLORS['korib_chiqilmoqda']
    return (
        <span style={{
            background: s.bg, color: s.color,
            padding: '3px 10px', borderRadius: 12, fontSize: 13, fontWeight: 600,
            display: 'inline-block'
        }}>
            {s.label}
        </span>
    )
}

// Jadval ko'rish modali
function RowsViewModal({open, onClose, item, sectionType}) {
    const columns = SECTION_COLUMNS[sectionType] || []
    const rows = item?.rows || []
    const hasSarf = columns.some(c => c.key === 'sarf_mablag')
    const total = hasSarf
        ? rows.reduce((sum, r) => sum + (parseFloat((r.sarf_mablag || '').replace(/\s/g, '').replace(',', '.')) || 0), 0)
        : null

    if (!item) return null
    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
            <DialogTitle>
                {item.user?.user_name || ''} — {item.year || ''}
            </DialogTitle>
            <DialogContent>
                <div style={{overflowX: 'auto'}}>
                    <table className="table table-bordered" style={{borderCollapse: 'collapse', width: '100%'}}>
                        <thead>
                        <tr style={{background: '#f0f0f0'}}>
                            <th style={{padding: '8px', textAlign: 'center', width: 40}}>#</th>
                            {columns.map(c => (
                                <th key={c.key} style={{padding: '8px', textAlign: 'center'}}>{c.label}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {rows.map((row, i) => (
                            <tr key={i}>
                                <td style={{textAlign: 'center', padding: '6px'}}>{i + 1}</td>
                                {columns.map(c => (
                                    <td key={c.key} style={{padding: '6px'}}>{row[c.key] || '—'}</td>
                                ))}
                            </tr>
                        ))}
                        {hasSarf && total > 0 && (
                            <tr style={{fontWeight: 'bold', background: '#fafafa'}}>
                                <td colSpan={columns.length} style={{textAlign: 'right', padding: '8px'}}>Жами:</td>
                                <td style={{padding: '8px', textAlign: 'center'}}>{total.toLocaleString('uz-UZ')}</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                    {item.text && <p style={{marginTop: 12, color: '#555'}}><b>Изоҳ:</b> {item.text}</p>}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">Ёпиш</Button>
            </DialogActions>
        </Dialog>
    )
}

// Biznes-reja status modal (admin uchun)
function StatusModal({open, onClose, item, onSave}) {
    const [selStatus, setSelStatus] = useState('')
    const [rejectReason, setRejectReason] = useState('')
    const [adminFile, setAdminFile] = useState(null)
    const [adminFileName, setAdminFileName] = useState('')

    useEffect(() => {
        if (item) {
            setSelStatus(item.status || 'korib_chiqilmoqda')
            setRejectReason(item.reject_reason || '')
            setAdminFile(null)
            setAdminFileName('')
        }
    }, [item])

    function handleSave() {
        const data = {status: selStatus, reject_reason: rejectReason}
        if (adminFile) data.admin_file = adminFile
        onSave(item.id, data)
        onClose()
    }

    if (!item) return null
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Status o'zgartirish</DialogTitle>
            <DialogContent>
                <div style={{display: 'flex', flexDirection: 'column', gap: 16, paddingTop: 8}}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Status</InputLabel>
                        <Select value={selStatus} label="Status" onChange={e => setSelStatus(e.target.value)}>
                            <MenuItem value="korib_chiqilmoqda">Ko'rib chiqilmoqda</MenuItem>
                            <MenuItem value="tasdiqlandi">Tasdiqlandi ✅</MenuItem>
                            <MenuItem value="rad_etildi">Rad etildi ❌</MenuItem>
                        </Select>
                    </FormControl>

                    {selStatus === 'rad_etildi' && (
                        <TextField
                            label="Rad etish sababi"
                            multiline rows={3}
                            value={rejectReason}
                            onChange={e => setRejectReason(e.target.value)}
                            size="small" fullWidth
                        />
                    )}

                    {selStatus === 'tasdiqlandi' && (
                        <div>
                            <p style={{margin: '0 0 8px', fontSize: 14}}>Тасдиқланган файл (ихтиёрий):</p>
                            <Button variant="contained" component="label" size="small">
                                Файл танлаш
                                <input hidden type="file" onChange={e => {
                                    const f = e.target.files[0]
                                    if (f) { setAdminFile(f); setAdminFileName(f.name) }
                                }}/>
                            </Button>
                            {adminFileName && <span style={{marginLeft: 8, fontSize: 13}}>{adminFileName}</span>}
                        </div>
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">Бекор</Button>
                <Button onClick={handleSave} variant="contained" color="primary">Сақлаш</Button>
            </DialogActions>
        </Dialog>
    )
}

function Sections(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'))
    const navigate = useNavigate()
    const {t} = useTranslation()
    const params = useParams()
    const sectionType = params.sectionType
    const regionId = params.id || false
    const pageTitle = t(SECTION_LABELS[sectionType] || sectionType)
    const isTable = !!SECTION_COLUMNS[sectionType]  // kuzgi/yongin/mehnat -> jadval

    const [searchCompany, setSearchCompany] = useState('')
    const [openDelete, setOpenDelete] = useState(false)
    const [deleteItem, setDeleteItem] = useState(null)
    const [page, setPage] = useState(1)
    const [adminRegionId, setAdminRegionId] = useState('')
    const [searchTimer, setSearchTimer] = useState(null)

    const [viewItem, setViewItem] = useState(null)
    const [statusItem, setStatusItem] = useState(null)

    function fetchData(pg, sc) {
        const _rid = regionId || adminRegionId || ''
        const _sc  = sc !== undefined ? sc : searchCompany
        props.getSectionReports(sectionType, pg || page, PAGE_SIZE, _sc, _rid)
    }

    function handleAdminFilter({regionId: r}) {
        const rid = r || ''
        setAdminRegionId(rid); setPage(1)
        props.getSectionReports(sectionType, 1, PAGE_SIZE, searchCompany, rid)
    }

    useEffect(() => { fetchData(1, '') }, [sectionType])

    useEffect(() => {
        if (searchTimer) clearTimeout(searchTimer)
        const timer = setTimeout(() => { setPage(1); fetchData(1, searchCompany) }, 400)
        setSearchTimer(timer)
    }, [searchCompany])

    useEffect(() => {
        if (props.verify === false) navigate("/login/")
    }, [props.verify])

    useEffect(() => {
        if (props.message === 'deleted') {
            toast.success(t('delete_success'), {theme: 'colored'})
            props.messageReset(); fetchData()
        } else if (props.message === 'status_updated') {
            toast.success(t('save_success'), {theme: 'colored'})
            props.messageReset()
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'}); props.messageReset()
        }
    }, [props.message])

    function handlePageChange(e, value) {
        setPage(value); fetchData(value)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }

    function monthSelect(val) {
        const map = {1: t('quarter'), 2: t('semi_annual'), 3: t('nine_month'), 4: t('yearly')}
        return map[Number(val)] || '—'
    }

    function getFullDateTime(val) {
        if (!val) return '-'
        const d = new Date(val)
        const p = n => String(n).padStart(2, '0')
        return `${p(d.getDate())}.${p(d.getMonth()+1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`
    }

    function handleDeleteConfirm() {
        if (deleteItem) props.deleteSectionReport(deleteItem)
        setOpenDelete(false); setDeleteItem(null)
    }

    function handleStatusSave(id, data) {
        const formData = new FormData()
        Object.entries(data).forEach(([k, v]) => { if (v !== undefined && v !== null) formData.append(k, v) })
        props.updateSectionStatus(id, formData)
    }

    const items = props.sectionReports || []

    return (
        <div>
            <div className={'page worker-page'}>
                <Header/><Dashboard/>
                <Box component="main" sx={{flexGrow:1, height:'100vh', overflow:'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>{t('back')}</Button>
                        <div className={'header-page'}>
                            <h2 className={'page-title'}>{pageTitle}</h2>
                            {!is_main && (
                                <Button variant="contained" endIcon={<AddIcon/>}
                                        onClick={() => navigate(`/add-section/${sectionType}/`)}>
                                    {t('add')}
                                </Button>
                            )}
                        </div>

                        {is_main && !regionId && (
                            <div style={{marginBottom: 16}}>
                                <FormControl variant="outlined" style={{minWidth: 300}}>
                                    <InputLabel htmlFor="search-section">{t('search_company')}</InputLabel>
                                    <OutlinedInput id="search-section" value={searchCompany}
                                                   onChange={e => setSearchCompany(e.target.value)}
                                                   endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                                                   label={t('search_company')}/>
                                </FormControl>
                            </div>
                        )}

                        {is_main && !regionId && <AdminFilter onFilter={handleAdminFilter}/>}

                        {items.length ? (
                            <table className="table table-hover table-responsive">
                                <thead><tr>
                                    <th>#</th>
                                    {is_main && <th>{t('title_company')}</th>}
                                    <th>Йил</th>
                                    <th>Давр</th>
                                    {isTable ? (
                                        <th>Жадвал</th>
                                    ) : (
                                        <>
                                            <th>{t('download')}</th>
                                            {sectionType === 'biznes_reja' && (
                                                <>
                                                    <th>Статус</th>
                                                    <th>Юборилган вақт</th>
                                                    <th>Тасдиқланган вақт</th>
                                                    <th>Тасд. файл</th>
                                                </>
                                            )}
                                        </>
                                    )}
                                    {is_main && <th>{t('section_sent_time')}</th>}
                                    <th/>
                                </tr></thead>
                                <tbody>
                                {items.map((item, index) => (
                                    <tr key={item.id}>
                                        <th>{(page-1)*PAGE_SIZE+index+1}</th>
                                        {is_main && <td>{item.user?.user_name || 'ADMIN'}</td>}
                                        <td>{item.year || '—'}</td>
                                        <td>{monthSelect(item.month)}</td>

                                        {isTable ? (
                                            <td>
                                                <Button size="small" variant="outlined"
                                                        onClick={() => setViewItem(item)}>
                                                    Ko'rish ({(item.rows || []).length} qator)
                                                </Button>
                                            </td>
                                        ) : (
                                            <>
                                                <td>
                                                    {item.file
                                                        ? <a href={item.file} target={'_blank'} rel="noreferrer"><DownloadIcon/></a>
                                                        : '—'}
                                                </td>
                                                {sectionType === 'biznes_reja' && (
                                                    <>
                                                        <td>
                                                            <StatusBadge status={item.status}/>
                                                            {item.reject_reason && (
                                                                <div style={{fontSize: 12, color: '#842029', marginTop: 4}}>
                                                                    {item.reject_reason}
                                                                </div>
                                                            )}
                                                            {is_main && (
                                                                <Button size="small" variant="text"
                                                                        onClick={() => setStatusItem(item)}
                                                                        style={{marginTop: 4, display: 'block'}}>
                                                                    O'zgartirish
                                                                </Button>
                                                            )}
                                                        </td>
                                                        <td style={{whiteSpace:'nowrap',fontSize:'13px'}}>
                                                            {getFullDateTime(item.created_time)}
                                                        </td>
                                                        <td style={{whiteSpace:'nowrap',fontSize:'12px'}}>
                                                            {item.approved_at ? getFullDateTime(item.approved_at) : '—'}
                                                        </td>
                                                        <td>
                                                            {item.admin_file
                                                                ? <a href={item.admin_file} target={'_blank'} rel="noreferrer">
                                                                    <DownloadIcon/> Тасд.
                                                                </a>
                                                                : '—'}
                                                        </td>
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {is_main && <td style={{whiteSpace:'nowrap'}}>{getFullDateTime(item.created_time)}</td>}
                                        <td>
                                            <Button variant="contained" color="error" endIcon={<DeleteIcon/>}
                                                    onClick={() => { setDeleteItem(item); setOpenDelete(true) }}/>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        ) : <div className={'no-infos'}>{t('no_info')}</div>}

                        {props.total_pages > 1 && (
                            <div style={{display:'flex', justifyContent:'center', padding:'20px 0'}}>
                                <Pagination count={props.total_pages} page={page} onChange={handlePageChange}
                                            color="primary" shape="rounded"/>
                            </div>
                        )}
                    </div>
                    <Copyright/>
                </Box>
            </div>

            {/* Jadval ko'rish modali */}
            <RowsViewModal
                open={!!viewItem}
                onClose={() => setViewItem(null)}
                item={viewItem}
                sectionType={sectionType}
            />

            {/* Biznes-reja status modali */}
            <StatusModal
                open={!!statusItem}
                onClose={() => setStatusItem(null)}
                item={statusItem}
                onSave={handleStatusSave}
            />

            {/* O'chirish modali */}
            <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
                <DialogTitle>{t('delete_title')}</DialogTitle>
                <DialogContent><DialogContentText>{t('delete_desc')}</DialogContentText></DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDelete(false)} variant="contained">{t('cancel')}</Button>
                    <Button onClick={handleDeleteConfirm} variant="contained" color="error">{t('delete')}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default connect(props => props.sectionReport, {
    getSectionReports, deleteSectionReport, updateSectionStatus, getAllVerifyResponse, messageReset
})(Sections)